// neurotrader-admin/src/layouts/AdminLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
// Vamos criar esses componentes a seguir
import AdminSidebar from '../components/AdminSidebar';
import AdminHeader from '../components/AdminHeader';
import AdminBottomNav from '../components/AdminBottomNav';

// (Pode criar um AdminLayout.css se quiser)
const styles = {
    layout: { display: 'flex' },
    wrapper: { flexGrow: 1, display: 'flex', flexDirection: 'column', height: '100vh' },
    content: { flexGrow: 1, padding: '30px', overflowY: 'auto', backgroundColor: 'var(--dark-bg)' }
};

const AdminLayout = () => {
    return (
        <div style={styles.layout}>
            <AdminSidebar />
            <div style={styles.wrapper}>
                <AdminHeader />
                <main style={styles.content}>
                    <Outlet /> {/* Onde as páginas do admin serão renderizadas */}
                </main>
            </div>
            <AdminBottomNav />
        </div>
    );
};

export default AdminLayout;